import * as Sentry from '@sentry/react';

export function initSentry(): void {
    // Trava dura por ambiente: so o build de producao envia pro painel.
    // `npm run dev` roda com MODE=development e import.meta.env.PROD=false, entao
    // erro de dev (HMR, componente meio escrito, mock de API) nunca vira issue
    // misturada com erro real de usuario. Nao basta contar com VITE_SENTRY_DSN
    // vazio: o .env de producao acaba na maquina do dev mais cedo ou mais tarde.
    // Pra testar o Sentry fora de prod: VITE_SENTRY_FORCE_ENABLE=true.
    const forced = import.meta.env.VITE_SENTRY_FORCE_ENABLE === 'true';
    if (!import.meta.env.PROD && !forced) return;

    const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
    if (!dsn) return;

    Sentry.init({
        dsn,
        environment: (import.meta.env.MODE as string) ?? 'production',
        release: (import.meta.env.VITE_SENTRY_RELEASE as string | undefined) ?? undefined,
        tracesSampleRate: 0.1,
        // Sem replayIntegration de propósito: o gravador de DOM (rrweb) roda em
        // toda sessão mesmo com replaysSessionSampleRate=0, e pesa nas telas de
        // BI com tabelas grandes. Reavaliar quando o resto estiver estável.
        integrations: [Sentry.browserTracingIntegration()],
        sendDefaultPii: false,
        beforeSend(event) {
            const url = event.request?.url ?? '';
            if (url.includes('/api/debug/')) return null;
            return event;
        },
    });
}
